/* 🤖 this file was generated by svg-to-ts */
export const DfIconChevronLeft12: {
  name: 'chevron-left-12';
  data: string;
} = {
  name: 'chevron-left-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="m5.078 6 2.779 3.094a.557.557 0 0 1-.012.758.482.482 0 0 1-.703-.01L4.259 6.67a.993.993 0 0 1 0-1.338l2.883-3.174a.482.482 0 0 1 .703-.009c.202.212.207.54.012.758z" fill-rule="evenodd"/></svg>`
};
